import { Outlet } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/lib/theme';
import { Button, Tooltip } from './ui/primitives';

export function ThemeToggle({ className }: { className?: string }) {
  const { dark, toggle } = useTheme();
  return (
    <Tooltip content={dark ? 'Switch to light mode' : 'Switch to dark mode'} side="bottom">
      <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme" className={className}>
        {dark ? (
          <Sun key="sun" className="h-4 w-4 animate-in spin-in-45 fade-in-0 duration-200" />
        ) : (
          <Moon key="moon" className="h-4 w-4 animate-in spin-in-45 fade-in-0 duration-200" />
        )}
      </Button>
    </Tooltip>
  );
}

export function FloatingThemeToggle() {
  return (
    <div className="fixed end-3 top-3 z-40 print:hidden">
      <ThemeToggle className="rounded-full border bg-card/80 shadow-sm backdrop-blur hover:bg-accent" />
    </div>
  );
}

export function FloatingThemeToggleLayout() {
  return (
    <>
      <Outlet />
      <FloatingThemeToggle />
    </>
  );
}
